import { defineRecipe, defineStyle } from '@chakra-ui/react';

// Keyboard focus halo — same 3px indigo ring + `sm` radius used by Button /
// Input / Checkbox so the rounded shape matches the rest of the design system.
// Without an explicit borderRadius the box-shadow renders square because Link
// is inline with no intrinsic rounding.
const focusRing = {
  borderRadius: 'sm',
  boxShadow: 'focus',
  outline: 'none',
};

/*
 * v3 port notes: the built-in `link` recipe's default `variant: 'plain'`
 * sets its own `color`/`_hover` (including a hover underline-offset/color
 * bleed) — confirmed via `createSystem`/`getRecipeFn` that this app's
 * `baseStyle` needs restating under `variants.variant.plain` too, or the
 * built-in's values win. `nodecoration` is a separate variant key (doesn't
 * collide with the built-in's `underline`/`plain`), ported as-is — zero
 * real consumers currently (confirmed via grep), kept per this migration's
 * "port, not redesign" precedent.
 */
const baseStyle = defineStyle({
  color: 'fg.link',
  textUnderlineOffset: '2px',
  _hover: {
    textDecoration: 'underline',
    color: 'fg.linkHover',
    textUnderlineOffset: '2px',
    textDecorationColor: 'currentColor',
  },
  _focus: { textDecoration: 'none' },
  _focusVisible: { ...focusRing, textDecoration: 'underline' },
  _active: { textDecoration: 'underline' },
});

const nodecorationStyle = defineStyle({
  color: 'fg.link',
  _focus: { textDecoration: 'none' },
  _focusVisible: { ...focusRing, textDecoration: 'none' },
  _hover: { textDecoration: 'none', color: 'fg.linkHover' },
  _active: { textDecoration: 'none' },
});

export const linkTheme = defineRecipe({
  base: baseStyle,
  variants: {
    variant: {
      plain: baseStyle,
      nodecoration: nodecorationStyle,
    },
  },
  defaultVariants: {
    variant: 'plain',
  },
});

export default linkTheme;
